import { Directive, Input, ElementRef, Inject } from '@angular/core';

@Directive({
  selector: '[appFocusInput]'
})
export class FocusInputDirective {

  @Input()
  appFocusInput: boolean

  constructor(private element: ElementRef) { }
  protected ngOnChanges() {
    this.element.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/focus-input/focus-input.directive.ts